<template>
  <div style="width: 100%; margin-top: 16px;">

    <draggable v-model="optionsList" @end="sortEnd" ghostClass="ghost" handle=".drag-handle" animation="200"
      chosenClass="chosen" forceFallback delay="0" :disabled="isAnswerx">
      <div flex v-for="(item, index) in optionsList" :key="index" class="option-item drag-handle">
        <div style="margin-right: 10px;" class="questionSeq"
          :class="{ isTrue: (readonly || isAnswerx) && checkRight(item, index), isFalse: (readonly || isAnswerx) && !checkRight(item, index) }">
          {{ item.title }}</div>
        <!-- 添加拖拽手柄 -->
        <div class="questionContent">
          <img style="width: 20px; height: 20px; display: block; margin-left: 28px;"
            v-if="(readonly || isAnswerx) && checkRight(item, index)" src="../../../assets/images/new-right.png" alt="" />
          <img style="width: 20px; height: 20px; display: block; margin-left: 28px;"
            v-else-if="(readonly || isAnswerx) && !checkRight(item, index)" src="../../../assets/images/new-error.png"
            alt="" />
          <div class="drag-handle" style="margin-right: 10px; cursor: move;" v-if="!(readonly || isAnswerx)"></div>
          <bc-view-common flex-box="1" :content="item.content" :border="false" placeholder="点击编辑选项"
            :fileInfo="item.fileInfo"></bc-view-common>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>

import XEUtils from 'xe-utils'
let sortString = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
import draggable from 'vuedraggable'

export default {
  name: 'bc-option',
  components: { draggable },

  props: {
    options: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    answer: {
      type: Object,
      default: () => {
      }
    },
    questionInfo: {
      type: String,
      default: '',
    },
    isAnswerx: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      dialogTitle: '',
      optionsList: [],
      editIndex: null,
      editModel: 'create',
      sortString: sortString.split(''),

      answerStr: '',
      isDragging: false, // 添加拖拽状态标识
      isFirst: true,
    }
  },
  watch: {
    options: {
      handler(val) {
        // console.log(val, '发生了改变');
        if (this.isFirst) {
          this.optionsList = XEUtils.clone(val, true)
          this.isFirst = false
        }
        this.$nextTick(() => {
          this.answerStr = ''
          this.optionsList.forEach(item => {
            this.answerStr += item.title.toLocaleUpperCase()
          })
        })
        // 当options变化且为只读模式时，根据answer.answerResults重新排序
        if (this.readonly && this.answer && this.answer.answerResults) {
          this.sortOptionsByAnswer()
        }
      },
      immediate: true
    },
    // 监听answer变化，在只读模式下重新排序
    answer: {
      handler(val) {
        if (this.readonly && val && val.answerResults) {
          this.sortOptionsByAnswer()
        }
      },
      immediate: true
    }
  },
  methods: {
    // 根据answer.answerResults对optionsList进行排序
    sortOptionsByAnswer() {
      if (!this.answer.answerResults || !this.optionsList.length) return

      const answerOrder = this.answer.answerResults.split('')

      // 创建一个排序映射
      this.optionsList.sort((a, b) => {
        const indexA = answerOrder.indexOf(a.title)
        const indexB = answerOrder.indexOf(b.title)

        // 如果找不到对应的title，则放在最后
        if (indexA === -1) return 1
        if (indexB === -1) return -1

        return indexA - indexB
      })
    },
    sortEnd(evt) {
      // 设置拖拽状态
      this.isDragging = true
      console.log(evt, 'evtevtevt', this.optionsList);
      this.answerStr = ''
      this.optionsList.forEach(item => {
        this.answerStr += item.title.toLocaleUpperCase()
      })
      // 使用nextTick确保DOM更新完成后重置拖拽状态
      this.$nextTick(() => {
        if (this.isDragging) {
          this.$emit('change', this.answerStr)
        }
        this.isDragging = false
      })
    },
    blurInput() {

      let answer = this.answerStr.replace(/[^A-Z]+/ig, "")
      this.answerStr = answer.toLocaleUpperCase()
      this.$emit('change', this.answerStr)
    },
    checkRight(answer, anserIndex) {

      let stand = this.questionInfo.split("、")
      let flag = false
      stand.forEach((element, index) => {
        if (anserIndex == index) {
          if (element == answer.title) {
            flag = true
          }
        }

      });
      // console.log(answer.title, answer.index, flag, stand, anserIndex,'单选获取的answer');

      return flag
    }
  },
  mounted() {
    // console.log(this.answer, '排序获取的answer', this.optionsList, this.questionInfo);

  },
}
</script>

<style lang="scss" scoped>
.create-option {
  width: 100%;
  margin-top: 10px;
  border-style: dashed !important;
}

.option-item+.option-item {
  margin-top: 16px;
}

.option-item {
  // background: #FBFBFB;
  border-radius: 6px;
  // padding-left: 16px;
  // cursor: pointer;
  transition: all ease .3s;

  .questionSeq {
    padding: 12px 30px;
    margin-right: 12px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #27272A;
    line-height: 24px;
    background: #FBFBFB;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
    margin-right: 12px;
    display: flex !important;
    align-items: center;

    &.isTrue {
      // border: 1px solid #70B603;
      color: #18B451;
    }


    &.isFalse {
      // border: 1px solid #D9001B;
      color: #FF6565;
    }
  }

  .questionContent {
    flex: 1 1 0;
    background: #FBFBFB;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
    display: flex;
    align-items: center;

    .drag-handle {
      width: 24px;
      height: 24px;
      background-image: url('../../../assets/images/drag.png');
      background-position: center center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }

  &.isActive {
    .questionSeq {
      // background: #ddd;
    }

    .questionContent {
      background: #DCEBFE;

      .drag-handle {
        background-image: url('../../../assets/images/drag-select.png');
      }
    }

    // background: #ccc;
  }

  &:hover {
    .questionSeq {
      // background: #ddd;
    }

    .questionContent {
      background: #DCEBFE;

      .drag-handle {
        background-image: url('../../../assets/images/drag-select.png');
      }
    }

    // background: #ddd;
  }

  ::v-deep .content {
    cursor: pointer;

  }

  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
      cursor: pointer;

    }
  }


}

.answer-input {
  width: 100%;
  padding: 15px;
  background: #FBFBFB;
  border-radius: 6px;
  margin-top: 16px;

  &.isTrue {
    // border: 1px solid #70B603;
    color: #18B451;
  }


  &.isFalse {
    // border: 1px solid #D9001B;
    color: #FF6565;
  }

  .input {
    outline: none;
    height: 100%;
    width: 100%;
    background: transparent;
  }

}
</style>
